import { Component, OnInit ,Input} from '@angular/core';
import { FormGroup, FormBuilder,  Validators } from '@angular/forms';
import {Familiar} from '../../models/familiar';
import {Personal} from '../../models/personal';
import {generalService} from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import {MatDialog} from '@angular/material';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'my-familiar-addedit',
  styles: [],
  templateUrl: 'familiarAddEdit.component.html',
  providers: [generalService]
})

export class FamiliarAddEditComponent implements OnInit {
 
 @Input() familiar:Familiar;
 @Input() personal:Personal;
  familiarAgregar: FormGroup;
  titulo = "Agregar";
  list: any;
  person_id: string;


  constructor(private formBuilder: FormBuilder, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService, private route: ActivatedRoute) { 
    this.familiar = new Familiar();
    this.personal = new Personal();
    this.dataService.guardado=false;
    this.list = new Object;
    this.person_id = (this.route.snapshot.paramMap.get('id'));  }

  ngOnInit() {
    this.buildForm();
      this.getInit(this.dataService.idPersonal);

      if(this.dataService.tipo == "editar"){
        this.titulo = "Editar";
        this.familiar.idFamilar = this.dataService.id;
        this.buscarFamiliar(this.familiar.idFamilar);
      }
  }

    getInit(id:any){
      this._generalService.metodoCall(`familiar/getInit/${id}`).subscribe(
          result => {            
            let res = JSON.parse(result);
            
            this.personal.NAME = res.Table1[0].NAME;
            this.personal.LAST_NAME = res.Table1[0].LAST_NAME;
            this.personal.MOTHER_LAST_NAME = res.Table1[0].MOTHER_LAST_NAME;
            this.list.RelacionFamiliar = res.Table;
            // this.list.State = res.Table3;
            // this.list.City = res.Table4;
            },
          error => {
            console.log(<any>error);
          }
        );
    }

  buscarFamiliar(id:any){
      this._generalService.metodoCall(`familiar/consultarFamiliaresId/${id}`).subscribe(
        result => {
          this.familiar = JSON.parse(result.replace("[", "").replace("]", ""));     

           let fechas = this.familiar.fecha.split("/");
          this.familiar.fecha = new Date(fechas[2], fechas[1] - 1, fechas[0]);     
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  buildForm() {
    this.familiarAgregar = this.formBuilder.group({
       personalNombre: this.formBuilder.control(null,),
      personalPaterno: this.formBuilder.control(null ),
     personalMaterno: this.formBuilder.control(null),
      familiarNombre: this.formBuilder.control(null,[Validators.required, Validators.maxLength(250)]),
      familiarPaterno: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      familiarMaterno: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
       relacion: this.formBuilder.control(null,[Validators.required]),
        fechaNacimiento: this.formBuilder.control(null)
    });
    this.familiarAgregar.get('personalNombre').disable();
    this.familiarAgregar.get('personalPaterno').disable();
    this.familiarAgregar.get('personalMaterno').disable();
  }

  cerrarModal(){
    this.dataService.dialogRef.close();
  }

  onSubmit() {
      let metodo = "familiar/agregarFamiliar";
      if(this.dataService.tipo == "editar"){
        metodo = "familiar/actualizarFamiliar";
      }
      this.familiar.idPersonal = this.dataService.idPersonal;
     
      this._generalService.metodoCallParams(this.familiar, metodo).subscribe(
          result => {
            this.dataService.guardado=true;
            this.cerrarModal();
          },
          error => {
            var errorMsj = <any>error;
            console.log(errorMsj);
          }
      ); 
  }
}



// WEBPACK FOOTER //
// ./src/app/familiar/agregar-editar/familiarAddEdit.component.ts